import React from 'react';
import Rheostat from 'rheostat';
import geometric from './geometric';
import PropTypes from 'prop-types';
import * as Analytics from 'analytics';
import qs from 'qs';
import { Spinner } from 'components'

// TOOD: Rename component to "range"? To avoid confusion with the price-slider container

class PriceRange extends React.Component {

    constructor(props) {
        super(props);
        this.navigateEvent = props.navigateEvent || 'ui:navigate';
        this.state = {
            //set starting position for handle
            usedSlider: false,
            min: props.handleStart || 1,
            max: props.handleEnd || '',
            loading: false,
            lastSearchMin: props.handleStart || 1,
            lastSearchMax: props.handleEnd === props.rangeEnd ? null : props.handleEnd
        };
        this.formElement = null;
    }

    setFormReference = el => {
        this.formElement = el;
    };

    /**
     * @description Handles min value changing in price slider
     * @param {object} event syntehtic event contains value `event.target.value`
     * @memberof PriceRange
     */
    handleMinChange = event => {
        const {
            min
        } = this.state;
        const val = event.target.value;

        //if user inputs string or isn't number;
        if (val === '' || isNaN(val)) {
            this.setState({
                min: val === '' ? 1 : min
            });
            return;
        }

        this.setState({
            min: parseInt(event.target.value, 10)
        });
    }

    /**
     * @description Handles max value changing in price slider
     * @param {object} event syntehtic event contains value `event.target.value`
     * @memberof PriceRange
     */
    handleMaxChange = event => {
        const {
            rangeEnd
        } = this.props;

        const {
            max
        } = this.state;
        const val = event.target.value ? parseInt(event.target.value, 10) : null;

        if (val === '' || isNaN(val)) {
            this.setState({
                max: val === '' ? rangeEnd : max
            });
            return;
        }

        this.setState({
            max: val > 5000 ? 5000 : val
        });

        if (val > 4999) {
            event.currentTarget.blur();
        }
    }

    stateHasChangedSinceStart = (inputMinValue, inputMaxValue) => {
        inputMinValue = parseInt(inputMinValue, 10);
        inputMaxValue = inputMaxValue.length > 0 ? parseInt(inputMaxValue, 10) : null

        if (inputMinValue !== this.state.lastSearchMin ||
            inputMaxValue !== this.state.lastSearchMax) {
            return true;
        }

        return false;
    }

    gotoNewURL = () => {
        const {
            gaCategory
        } = this.props;

        const minInput = this.formElement.querySelector('.price-range__min');
        const maxInput = this.formElement.querySelector('.price-range__max');
        const inputs = [minInput, maxInput];
        if (!this.stateHasChangedSinceStart(minInput.value, maxInput.value)) {
            return;
        }

        for (let index = 0; index < inputs.length; index++) {
            if (document.activeElement === inputs[index]) {
                return;
            }
        }

        const search = () => {
            const formElements = Array.from(this.formElement.elements);
            const inputs = formElements.filter(el => {
                return el.tagName.toLocaleLowerCase() === 'input';
            });

            const urlParamsAsObject = inputs.reduce((acc, cur) => {
                if (cur.value) { // Only keep params with value
                    acc[cur.name] = cur.value;
                }
                return acc;
            }, {});

            urlParamsAsObject['expanded'] = 1; // Make sure expanded is set to 1. Then we wont scroll to top after pjax.
            const url = this.formElement.action + '?' + qs.stringify(urlParamsAsObject);

            $(document).trigger(this.navigateEvent, { href: url }); // TODO: Change to a regular event when we support it
        }

        this.setState({
            loading: true
        });

        const value = `${this.state.min} - ${this.state.max}`;
        Analytics.trackEvent({
            category: gaCategory,
            action: 'Interaction',
            label: 'Filter - PriceRange Slider | ' + value
        });

        setTimeout(search, 1); // Hack to make sure its called after the handleValuesChanging::setState
    }

    handleValuesChanging = response => {
        this.setState({
            min: response.values[0],
            max: response.values[1]
        });
    }

    renderUrlParamsAsElements = () => {
        const allUrlParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        const reservedParams = [
            'fromPrice',
            'toPrice'
        ];

        if (Object.keys(allUrlParams).length > 0) {
            const relevantUrlParams = Object.keys(allUrlParams).filter(paramName => {
                return (reservedParams.indexOf(paramName) < 0);
            });
            return relevantUrlParams.map(paramName => {
                return (
                    <input type="hidden" name={paramName} key={paramName} value={allUrlParams[paramName]} />
                );
            })
        }
    }

    inputMinLength = () => {
        return '0' === this.state.min.toString().length ? 1 : this.state.min.toString().length;
    }

    inputMaxLength = () => {
        return '0' === this.state.max.toString().length ? 1 : this.state.max.toString().length;
    }

    render() {
        const {
            algorithm,
            rangeStart,
            gaCategory,
            rangeEnd
        } = this.props;

        const isMax = this.state.max === rangeEnd || this.state.max > rangeEnd;
        const limitedMax = isMax ? rangeEnd : this.state.max;

        const handleInputBlur = evt => {
            const label = evt.target.name === 'toPrice' ? 'Filter - PriceRange MaxBlur' : 'Filter - PriceRange MinBlur';
            Analytics.trackEvent({
                category: gaCategory,
                action: 'Interaction',
                label: label,
                value: evt.target.value ? parseInt(evt.target.value, 10) : null
            });
            this.gotoNewURL();
        };

        const handleSliderInteraction = () => {
            this.gotoNewURL();
        }

        return (
            <form className={this.state.loading ? 'price-range__form price-range__form--loading' : 'price-range__form'} method="get" action={window.location.pathname} ref={this.setFormReference}>
                {this.renderUrlParamsAsElements()}
                {this.state.loading ?
                    <Spinner className="price-range__spinner" />
                    : null}
                <span className="price-range__value">
                    <input type="text" className="price-range__min"
                        data-price-range-min
                        size={this.inputMinLength()}
                        value={this.state.min}
                        name="fromPrice"
                        onChange={this.handleMinChange}
                        onBlur={handleInputBlur}
                        autoComplete="off" />
                    <label className="price-range__appendix price-range__appendix--min" htmlFor="price-range__min">kr</label>
                </span>
                <span className="price-range__value">
                    {
                        !isMax ?
                            <label className="price-range__appendix price-range__appendix--max" htmlFor="price-range__max">kr {this.state.max === rangeEnd ? '+' : ''}</label> : ''
                    }
                    <input type="text" className="price-range__max"
                        data-price-range-max
                        size={this.inputMaxLength()}
                        name="toPrice"
                        value={isMax ? '' : this.state.max}
                        onChange={this.handleMaxChange}
                        onBlur={handleInputBlur}
                        placeholder='Alla'
                        autoComplete="off" />
                </span>
                <div className="price-range__slider-wrapper">
                    <Rheostat
                        className={`price-range__slider`}
                        min={rangeStart}
                        max={rangeEnd}
                        algorithm={algorithm || geometric}
                        onValuesUpdated={this.handleValuesChanging}
                        onChange={handleSliderInteraction}

                        values={[
                            this.state.min,
                            limitedMax
                        ]} />
                </div>
            </form>
        )
    }
};

PriceRange.propTypes = {
    handleStart: PropTypes.number.isRequired,
    handleEnd: PropTypes.number.isRequired,
    rangeStart: PropTypes.number.isRequired,
    rangeEnd: PropTypes.number.isRequired,
    gaCategory: PropTypes.string.isRequired,
    algorithm: PropTypes.object
};

// export default PriceRange;
export default PriceRange;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/price-range/price-range.jsx